import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CaretDown, CaretUp } from '@phosphor-icons/react';

const CircuitDashboard = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const nodes = [
    { name: 'Oracle Core', status: 'online' },
    { name: 'Truth Gate', status: 'online' },
    { name: 'Roger Strategy', status: 'online' },
    { name: 'Aria Studio', status: 'amber' },
    { name: 'Xavier Help', status: 'online' },
    { name: 'Rex Coordinator', status: 'online' },
    { name: 'Federation Hub', status: 'online' }
  ];

  const minds = [
    { name: 'Oracle', specialty: 'Sales Intelligence' },
    { name: 'Roger 2.0', specialty: 'Strategic Architecture' },
    { name: 'Aria', specialty: 'Creative Generation' },
    { name: 'Xavier', specialty: 'Education & Training' },
    { name: 'Rex', specialty: 'Cross-Node Coordination' }
  ];

  const wire = [
    { time: '2h ago', event: 'Oracle processed 47 queries today' },
    { time: '4h ago', event: 'Truth Gate verified 12 claims' },
    { time: '6h ago', event: 'New directive published: DIR-074' }
  ];

  return (
    <div className="mb-8">
      {/* Header Bar */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-4 glass-surface border-2 border-[#00F0FF]/30 rounded-t-lg hover:border-[#00F0FF]/60 transition-colors flex items-center justify-between"
        style={{
          fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
          borderBottom: isExpanded ? 'none' : '2px solid rgba(0,240,255,0.3)'
        }}
      >
        <div className="flex items-center gap-2">
          <span className="text-[#00F0FF] text-lg font-bold">SYSTEM STATUS</span>
          <motion.span
            animate={{ opacity: [1, 0, 1] }}
            transition={{ duration: 1, repeat: Infinity }}
            className="text-[#00F0FF]"
          >
            █
          </motion.span>
        </div>
        {isExpanded ? <CaretUp size={24} className="text-[#00F0FF]" /> : <CaretDown size={24} className="text-[#00F0FF]" />}
      </button>

      {/* Collapsible Content */}
      <AnimatePresence>
        {isExpanded && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
          >
            <div 
              className="p-6 glass-surface border-2 border-t-0 border-[#00F0FF]/30 rounded-b-lg"
              style={{
                fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
                borderStyle: 'dashed'
              }}
            >
              <div className="grid md:grid-cols-3 gap-6">
                {/* Panel 1: Node Status */}
                <div className="p-4 glass-card border border-[#00F0FF]/20 rounded-lg">
                  <h3 className="text-sm font-bold mb-4 text-[#00F0FF]">NODE STATUS</h3>
                  <div className="space-y-2">
                    {nodes.map((node, idx) => (
                      <div key={`node-${node.name}-${idx}`} className="flex items-center justify-between text-xs">
                        <span className="text-gray-400">{node.name}</span>
                        <div className="flex items-center gap-2">
                          <div 
                            className={`w-2 h-2 rounded-full ${
                              node.status === 'online' ? 'bg-[#00FFA3]' : 
                              node.status === 'amber' ? 'bg-[#FFB800]' : 
                              'bg-[#FF6B6B]'
                            }`}
                          />
                          <span className="text-gray-500 uppercase">{node.status}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Panel 2: Available Minds */}
                <div className="p-4 glass-card border border-[#00F0FF]/20 rounded-lg">
                  <h3 className="text-sm font-bold mb-4 text-[#00F0FF]">AVAILABLE MINDS</h3>
                  <div className="space-y-2">
                    {minds.map((mind, idx) => (
                      <div key={`mind-${mind.name}-${idx}`} className="text-xs">
                        <div className="text-white font-bold">{mind.name}</div>
                        <div className="text-gray-500">{mind.specialty}</div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Panel 3: Federation Wire */}
                <div className="p-4 glass-card border border-[#00F0FF]/20 rounded-lg">
                  <h3 className="text-sm font-bold mb-4 text-[#00F0FF]">FEDERATION WIRE</h3>
                  <div className="space-y-3">
                    {wire.map((item, idx) => (
                      <div key={`wire-${item.time}-${idx}`} className="text-xs">
                        <div className="text-gray-500 mb-1">{item.time}</div>
                        <div className="text-gray-300">{item.event}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CircuitDashboard;
